"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSameFirstDrawFee = isSameFirstDrawFee;
exports.filterOffersByFirstDrawFee = filterOffersByFirstDrawFee;
exports.getAvailableFirstDrawFees = getAvailableFirstDrawFees;
exports.resolveInitialFirstDrawFee = resolveInitialFirstDrawFee;
const offer_1 = require("../offer");
const FIRST_DRAW_FEE_EPSILON = 0.000001;
function offerOneTimeFeePercent(offer) {
    if (offer.originationFeePercent == null && offer.firstDrawFeePercent == null) {
        return null;
    }
    return (0, offer_1.resolveUpfrontFee)({ originationFeePercent: offer.originationFeePercent, firstDrawFeePercent: offer.firstDrawFeePercent }).percent;
}
function isSameFirstDrawFee(left, right) {
    return Math.abs(left - right) < FIRST_DRAW_FEE_EPSILON;
}
function filterOffersByFirstDrawFee(offers, firstDrawFee) {
    return offers.filter((offer) => {
        const fee = offerOneTimeFeePercent(offer);
        return fee != null && isSameFirstDrawFee(fee, firstDrawFee);
    });
}
function getAvailableFirstDrawFees(offers) {
    const seen = new Set();
    const fees = [];
    for (const offer of offers) {
        const fee = offerOneTimeFeePercent(offer);
        if (fee == null) {
            continue;
        }
        if (!seen.has(fee)) {
            seen.add(fee);
            fees.push(fee);
        }
    }
    return fees.sort((a, b) => b - a);
}
function resolveInitialFirstDrawFee(offers, existingUwSpecId) {
    const available = getAvailableFirstDrawFees(offers);
    if (existingUwSpecId != null) {
        const match = offers.find((o) => o.uwSpecId === existingUwSpecId);
        const matchFee = match ? offerOneTimeFeePercent(match) : null;
        if (matchFee != null) {
            return matchFee;
        }
    }
    return available[0] ?? 0;
}
